module.exports = __webpack_public_path__ + "img/青岛地铁深色背景.654b60b1.png";